import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';

const Logo = ({ col = 3, isShopee, className, image, name, defaultName, link }) => {
  const tName = $t(name);
  const imgUrl = image || '';

  return (
    <ReactWOW animation="fadeInUp" delay="0.1s">
      <div className={`col-6 ${isShopee ? 'col-md-4 shopee' : 'col-md-' + col} ${className || ""}`}>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          {
            image ? (
              <img src={imgUrl} alt={tName} className={"img-logo " + (className || "")} />
            ) : (
              <p className="no-logo">{tName || defaultName}</p>
            )
          }
          <p className="name">{tName || defaultName}</p>
        </a>
      </div>
    </ReactWOW>
  )
}

const Partners = ({ message }) => message ? (
  <section id="partners" className="partners white">
    <h2 className="section-title">{$t(message.title)}</h2>
    <div className="container">
      {
        message.sections.map(section => 
          <div key={section.title}>
            <h2 className="title">{$t(section.title) || section.defaultTitle}</h2>
            <div className={`row ${section.justifyCenter ? 'justify-content-center' : ''}`}>
              {
                section.logos.map(logo =>
                  <Logo
                    key={logo.name}
                    name={logo.name}
                    image={logo.image}
                    link={logo.link}
                    className={logo.className}
                    isShopee={logo.isShopee}
                    defaultName={logo.defaultName}
                    col={logo.col}
                  />
                )
              }
            </div>
          </div>
        )
      }
    </div>
  </section>
) : null;

export default Partners;
